import { render } from "./StickyTableHeader.vue?vue&type=template&id=a4e7235e&scoped=true"
import script from "./StickyTableHeader.vue?vue&type=script&lang=js"
export * from "./StickyTableHeader.vue?vue&type=script&lang=js"

import "./StickyTableHeader.vue?vue&type=style&index=0&id=a4e7235e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4e7235e"]])

export default __exports__